import React from 'react'
import { Button, withStyles } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const styles = theme => ({
  root: {
    display: 'inline-block',
    paddingTop: 3,
    paddingBottom: 2,
    paddingLeft: 8,
    paddingRight: 8,
    color: theme.palette.primary.main,
    // backgroundColor: theme.palette.primary.highlight,
    borderColor: `rgba(0,0,0,.12)`,
    '& .MuiButton-label': {
      ...theme.typography.body1,
      lineHeight: 0,
      textTransform: 'none',
      letterSpacing: 0,
      display: 'flex'
    },
    '& .MuiButton-endIcon': {
      marginLeft: 0
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 5,
      paddingRight: 5,
    }
  },
})

const SedaScatterplotAxisButton = React.forwardRef(
  (
    {
      children,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        variant='outlined'
        size='small'
        // color='primary'
        endIcon={<ArrowDropDownIcon />}
        ref={ref}
        {...props}
      >
        {children}
      </Button>
    )
  }
)

SedaScatterplotAxisButton.displayName = 'SedaScatterplotAxisButton'

export default withStyles(styles)(SedaScatterplotAxisButton)